import { DOCS_FORM_NAMES } from "core/consts";
import { ControlledTextarea } from "ds/ui";
import { FormFieldConfig } from "../..";

export const DischargeLetterFormSections: FormFieldConfig<
  typeof DOCS_FORM_NAMES.DISCHARGE_LETTER_ENT
>["sections"] = [
  {
    fields: {
      test1: {
        input: () => (
          <ControlledTextarea label="test1" name="test1" placeholder=" " />
        ),
        position: 1,
      },
      test2: {
        input: () => (
          <ControlledTextarea label="test2" name="test2" placeholder=" " />
        ),
        position: 2,
      },
      test3: {
        input: () => (
          <ControlledTextarea label="test3" name="test3" placeholder=" " />
        ),
        position: 3,
      },
      test4: {
        input: () => (
          <ControlledTextarea label="test4" name="test4" placeholder=" " />
        ),
        position: 4,
      },
      test5: {
        input: () => (
          <ControlledTextarea label="test5" name="test5" placeholder=" " />
        ),
        position: 5,
      },
    },
    position: 1,
    title: () => "test",
  },
];
